export enum TicketResultEnum {
    Positive = 1,
    Negative = 2,
    Other = 3,
    OutsideJurisdiction = 4
}
